import request from '@/utils/request'

// 查询品牌申报通知公告列表
export function listTzgg(query) {
  return request({
    url: '/web/zlts/tzgg/list',
    method: 'get',
    params: query
  })
}

// 查询品牌申报通知公告详细
export function getTzgg(recid) {
  return request({
    url: '/web/zlts/tzgg/' + recid,
    method: 'get'
  })
}